export default "__VITE_ASSET__92c7185d__"